import {REGIONS} from '@constants/administration/gateway/iot-core-regions';

export class GatewayIot{
  cloudRegion!: REGIONS;
  registryId: string = '';
}